import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NeoTipoDocIdentidadService } from '../../../comun/services/neoTipoDocIdentidad.service';
import { NeoTipoDocIdentidad } from '../../../comun/models/neoTipoDocIdentidad';
import { AlertService } from '../../../services/alert.service';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { NeoRolService } from '../../../comun/services/neoRol.service';
import { Departamento } from '../../../comun/models/departamento';
import { Ciudad } from '../../../comun/models/ciudad';
import { NeoRol } from '../../../comun/models/neoRol';
import { ParametrosService } from 'src/app/services/parametros.service';
import { NeoUsuarioXRol } from '../../Model/neoUsuarioXRol';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NeoUsuarioIntermediario } from '../../Model/neoUsuarioIntermediario';
import { UserService } from 'src/app/services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
declare var $: any;

@Component({
    selector: 'app-editar-usuario-if',
    templateUrl: './editar-usuario-if.component.html',
    styleUrls: ['./editar-usuario-if.component.scss'],
    providers: [
        NeoTipoDocIdentidadService,
        NeoIntermediarioFinancieroService,
        NeoRolService,
        ParametrosService,
    ],
    standalone: false
})
export class EditarUsuarioIfComponent implements OnInit {
  editarUsuarioIFForm: UntypedFormGroup;
  listaDocumentos: NeoTipoDocIdentidad[] = [];
  public departamentos: Departamento[] = [];
  public listDepartamentos: Departamento[] = [];
  public ciudades: Ciudad[] = [];
  rolesDisponibles: UntypedFormControl = new UntypedFormControl('');
  rolesSeleccionados: UntypedFormControl = new UntypedFormControl('');
  listaRoles: NeoRol[] = [];
  listaRolesSeleccionados: NeoRol[] = [];
  listaRolesSeleccionadosId: Number[] = [];
  public neoUsuario: NeoUsuarioIntermediario;
  public neoUsuarioXRol: NeoUsuarioXRol;
  public user;
  /** Patrón lineal para evitar ReDoS; valida estructura local@dominio.ext */
  correoElectronicoFormato = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // NOSONAR - regex lineal, sin backtracking
  idusuario: Number;
  usuario: any;
  roles: any[] = [];

  constructor(
    private _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private _neoRolService: NeoRolService,
    private _parametrosService: ParametrosService,
    private _neoTipoDocIdentidadService: NeoTipoDocIdentidadService,
    private _userIntermediarioService: UserService,
    public router: Router,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private _sweetAlert:SweetAlertService
  ) {
    this.user = this._userIntermediarioService.getUser();
    this.neoUsuarioXRol = new NeoUsuarioXRol(
      this.neoUsuario,
      this.listaRolesSeleccionadosId
    );
    this.editarUsuarioIFForm = this.formBuilder.group({
      areaCompania: [''],
      cargo: ['', Validators.required],
      celular: ['', Validators.required],
      correoElectronico: [
        '',
        [
          Validators.required,
          Validators.pattern(this.correoElectronicoFormato),
        ],
      ],
      direccion: [''],
      extension: [''],
      idCiudad: ['', Validators.required],
      idDepartamento: ['', Validators.required],
      idUsuarioRegistro: [0],
      numeroDocumento: ['', Validators.required],
      primerApellido: ['', Validators.required],
      primerNombre: ['', Validators.required],
      segundoApellido: [''],
      segundoNombre: [''],
      telefonoFijo: [''],
      idCliente_NeoCliente: [0],
      idTipoDocIdentidad_NeoTipoDocIdentidad: ['', Validators.required],
      sucursalOficina: ['', Validators.required],
      estado: ['', Validators.required],
      idUsuario: ['', Validators.required],      
      ventaIncialAtendido: [null],
      ventaFinalAtendido: [null],
      departamentosSeleccionados: [null],
      aplicaTodosDepartamentos: false
    });
    this.route.params.subscribe((params: Params) => {
      this.idusuario = params['id'];
    });
  }

  ngOnInit(): void {
    this.formatPipe();
    this._neoIntermediarioFinancieroService.getListDepartamentosUbicaciones(this.user.idCliente).subscribe((resp: any) => {
      this._parametrosService.getDepartamentos('169').subscribe(
        (response) => {
          this.departamentos = response['data'];
          this.listDepartamentos = this.departamentos.filter((item: any) => resp.data.includes(item.idDepartamento));
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'Error al cargar los departamentos');
        }
      );
    });

    this._neoRolService.getRolesIF().subscribe(
      (response) => {
        this.listaRoles = response['roles'];
        return new Promise((resolve, reject) => {
          this.getUsuario();
        });
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar los roles');
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );

    this._neoTipoDocIdentidadService.getTiposDocIdentidad().subscribe(
      (response) => {
        this.listaDocumentos = response.filter(
          (documento) => documento.personaJuridica != 1 && documento.idTipoDocIdentidad != 4 && documento.idTipoDocIdentidad != 6
        );
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar los tipos de documento');
      }
    );
  }

  comparerRol(a: NeoRol, b: NeoRol) {
    if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
      return -1
    } else if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) {
      return 1
    } else {
      return 0
    }
  }

  getUsuario() {
    this._neoIntermediarioFinancieroService
      .getUsuarioIntermediario(this.idusuario, this.user.idUsuario)
      .subscribe(
        (response) => {
          if (response['exitoso'] == true) {
            this.usuario = response['usuario'];
            this.roles = response['roles'];
            this.roles.forEach((rol) => {
              this.cargarRoles(rol.idRol_NeoRol);
            });
            this.listaRolesSeleccionados.sort(this.comparerRol);
            this.listaRoles.sort(this.comparerRol);
            this.inicializarFormulario();
          } else {
            this._sweetAlert.errorModal("Error!",true,response['error']);
          }
        },
        (error) => {
          this._sweetAlert.errorModal("Error!",true,
            'No fue posible cargar los datos del usuario'
          );
          this.router.navigate([
            '/intermediario/administracion/modificarUsuarioIf',
          ]);
        }
      );
  }

  cargarRoles(i) {
    if (i != null) {
      this.listaRoles.forEach((rol, index) => {
        if (rol.idRol == i) {
          this.listaRolesSeleccionados.push(rol);
          this.listaRoles.splice(index, 1);
        }
      });
    }
  }

  inicializarFormulario() {
    this.editarUsuarioIFForm.get('idUsuario').setValue(this.usuario.idUsuario);
    this.editarUsuarioIFForm.get('cargo').setValue(this.usuario.cargo);
    this.editarUsuarioIFForm.get('celular').setValue(this.usuario.celular);
    this.editarUsuarioIFForm
      .get('correoElectronico')
      .setValue(this.usuario.correoElectronico);
    this.editarUsuarioIFForm
      .get('idDepartamento')
      .setValue(this.usuario.idDepartamento);
    this.editarUsuarioIFForm
      .get('idUsuarioRegistro')
      .setValue(this.usuario.idUsuarioRegistro);
    this.editarUsuarioIFForm
      .get('numeroDocumento')
      .setValue(this.usuario.numeroDocumento);
    this.editarUsuarioIFForm
      .get('primerApellido')
      .setValue(this.usuario.primerApellido);
    this.editarUsuarioIFForm
      .get('primerNombre')
      .setValue(this.usuario.primerNombre);
    this.editarUsuarioIFForm
      .get('segundoApellido')
      .setValue(this.usuario.segundoApellido);
    this.editarUsuarioIFForm
      .get('segundoNombre')
      .setValue(this.usuario.segundoNombre);
    this.editarUsuarioIFForm
      .get('idCliente_NeoCliente')
      .setValue(this.usuario.idCliente_NeoCliente);
    this.editarUsuarioIFForm
      .get('idTipoDocIdentidad_NeoTipoDocIdentidad')
      .setValue(this.usuario.idTipoDocIdentidad_NeoTipoDocIdentidad);
    this.editarUsuarioIFForm
      .get('sucursalOficina')
      .setValue(this.usuario.sucursalOficina);
    this.editarUsuarioIFForm.get('estado').setValue(this.usuario.estado);
    this.getCiudades(this.usuario.idDepartamento);
    this.editarUsuarioIFForm.get('idCiudad').setValue(this.usuario.idCiudad);
    this.editarUsuarioIFForm.get('ventaIncialAtendido').setValue(this.usuario.ventaIncialAtendido);
    this.editarUsuarioIFForm.get('ventaFinalAtendido').setValue(this.usuario.ventaFinalAtendido);
    this.editarUsuarioIFForm.get('departamentosSeleccionados').setValue(this.usuario.departamentosSeleccionados);
    this.editarUsuarioIFForm.get('aplicaTodosDepartamentos').setValue(this.usuario.aplicaTodosDepartamentos);
    this.actualizarDepartamentos();
    this.roles.forEach((rol) => {
      this.listaRoles.forEach((rolCargado, index) => {
        if (rol.idRol_NeoRol == rolCargado.idRol) {
          this.addRol();
        }
      });
    });
    this.loadSelectPiker();
  }

  loadSelectPiker() {
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    });
  }

  getCiudades(idDepartamento) {
  this.editarUsuarioIFForm.get('idCiudad').setValue('');
    if (idDepartamento != 'null' && idDepartamento != '' && idDepartamento != null) {
      this._parametrosService.getCiudades(idDepartamento).subscribe(
        (response) => {
          this.ciudades = response['data'];
        },
        (error) => {
          this._sweetAlert.errorModal("Error!",true,'Error al cargar las ciudades');
        }
      );
    } else {
      this.ciudades = [];
    }
  }

  isValidForm(field: string) {
    return (
      (this.editarUsuarioIFForm.get(field)?.dirty ||
        this.editarUsuarioIFForm.get(field)?.touched) &&
      this.editarUsuarioIFForm.get(field)?.invalid
    );
  }

  validateLetters(event: any) {
    const pattern = /[a-zA-Z áéíóúÁÉÍÓÚñÑ@&._$-]+/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateNumber(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateDocument(event: any) {
    if (
      this.editarUsuarioIFForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad')
        .value == 5 ||
      this.editarUsuarioIFForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad')
        .value == 3
    ) {
      const pattern = /[a-zA-Z0-9]/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    } else {
      this.validateNumber(event);
    }
  }
  validarSelect() {
    this.editarUsuarioIFForm.get('numeroDocumento').setValue('');
  }

  modificarUsuario() {
    this.neoUsuario = this.editarUsuarioIFForm.value;
    this.neoUsuario.idTipoDocIdentidad_NeoTipoDocIdentidad = Number(
      this.editarUsuarioIFForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad')
        .value
    );
    this.neoUsuario.idDepartamento = Number(
      this.editarUsuarioIFForm.get('idDepartamento').value
    );
    this.neoUsuario.idCiudad = Number(
      this.editarUsuarioIFForm.get('idCiudad').value
    );
    this.neoUsuario.ventaIncialAtendido = (this.editarUsuarioIFForm.get('ventaIncialAtendido').value != null &&
     this.editarUsuarioIFForm.get('ventaIncialAtendido').value != '') ? +this.editarUsuarioIFForm
      .get('ventaIncialAtendido').value.replace(/[.]/g, ''): null;
    this.neoUsuario.ventaFinalAtendido = (this.editarUsuarioIFForm.get('ventaFinalAtendido').value != null &&
    this.editarUsuarioIFForm.get('ventaFinalAtendido').value != '') ? +this.editarUsuarioIFForm
      .get('ventaFinalAtendido').value.replace(/[.]/g, ''): null;
    if (
      this.neoUsuario.idDepartamento != 0 &&
      this.neoUsuario.idTipoDocIdentidad_NeoTipoDocIdentidad != 0 &&
      this.neoUsuario.idCiudad != 0
    ) {
      if (this.listaRolesSeleccionados.length > 0) {
        if (this.user.idCliente != null && this.user.idUsuario != null) {
          if (this.neoUsuario.ventaIncialAtendido != null && this.neoUsuario.ventaFinalAtendido != null
            && (this.neoUsuario.ventaIncialAtendido > this.neoUsuario.ventaFinalAtendido)
          ) {
            this._sweetAlert.errorModal("Error!", true,
              "El valor 'Monto de ventas final atendido' no puede ser menor al valor 'Monto de ventas inicial atendido'.");
          } else if ((this.neoUsuario.ventaIncialAtendido == null && this.neoUsuario.ventaFinalAtendido != null) ||
            (this.neoUsuario.ventaIncialAtendido != null && this.neoUsuario.ventaFinalAtendido == null)) {
            this._sweetAlert.errorModal("Error!", true, "Debes diligenciar ambos valores del monto atendido.");
          } else {
            this.neoUsuario.idUsuarioRegistro = this.user.idUsuario;
            this.neoUsuario.idCliente_NeoCliente = this.user.idCliente;
            this.neoUsuarioXRol.usuario = this.neoUsuario;
            this.idRolesFormulario();
            this.neoUsuarioXRol.roles = this.idRoles();
            this._neoIntermediarioFinancieroService
              .saveUsuario(this.neoUsuarioXRol)
              .toPromise()
              .then((result) => {
                if (result.exitoso == true) {
                  this._sweetAlert.successModal('Éxito', false, 'Cambios Guardados'
                  ).then((result) => {
                    if (result.isConfirmed) {
                      this.router.navigate(['/intermediario/administracion/modificarUsuarioIf']);
                    }
                  });
                  // $('#aceptarModal').modal('show');
                } else {
                  this._sweetAlert.errorModal("Error!", true, result.error);
                }
              })
              .catch((err) => {
                this._sweetAlert.errorModal("Error!", true, 'Error al modificar usuario');
              });
          }
        } else {
          this._sweetAlert.errorModal("Error!",true,'Problema al cargar el usuario');
        }
      } else {
        this._sweetAlert.errorModal("Error!",true,'Seleccione los roles para usuario');
      }
    } else {
      this._sweetAlert.errorModal("Error!",true,'Faltan campos por seleccionar');
    }
  }

  addRol() {
    if(this.rolesDisponibles.value != ''){
      this.rolesDisponibles.value.map((id) => {
        const rol = this.listaRoles.find((roles) => roles.idRol == id);
        this.listaRolesSeleccionados.push(rol);
        this.listaRoles = this.listaRoles.filter((roles) => roles.idRol !== id);
      });
      this.rolesDisponibles.setValue('');
      this.listaRolesSeleccionados.sort(this.comparerRol);
      this.listaRoles.sort(this.comparerRol);
      this.refreshRol('#addRoles');
    }else{
      this._sweetAlert.errorModal("Error!",true,'Selecciona roles asignar.');
    }

  }

  addRolAll() {
    if(this.listaRoles.length != 0){
      this.listaRolesSeleccionados = this.listaRolesSeleccionados.concat(
        this.listaRoles
      );
      this.listaRoles = [];
      this.listaRolesSeleccionados.sort(this.comparerRol);
      this.refreshRol('#addRoles');
    }else{
      this._sweetAlert.errorModal("Error!",true,'No tienes roles para asignar.');
    }
  }

  removeRol() {
    if(this.rolesSeleccionados.value != ''){
      this.rolesSeleccionados.value.map((id) => {
        const rol = this.listaRolesSeleccionados.find(
          (roles) => roles.idRol == id
        );
        this.listaRoles.push(rol);
        this.listaRolesSeleccionados = this.listaRolesSeleccionados.filter(
          (roles) => roles.idRol !== id
        );
        this.rolesDisponibles.setValue(this.idRoles());
        this.listaRolesSeleccionados.sort(this.comparerRol);
        this.listaRoles.sort(this.comparerRol);
      });
      this.rolesSeleccionados.setValue('');
      this.refreshRol('#deleteRole');
    }else{
      this._sweetAlert.errorModal("Error!",true,'Selecciona roles a eliminar.');
    }
  }

  removeRolAll() {
    if(this.listaRolesSeleccionados.length != 0){
      this.listaRoles = this.listaRoles.concat(this.listaRolesSeleccionados);
      this.listaRolesSeleccionados = [];
      this.rolesSeleccionados.setValue('');
      this.listaRoles.sort(this.comparerRol);
      this.refreshRol('#deleteRole');
    }else{
      this._sweetAlert.errorModal("Error!",true,'No tienes roles a eliminar.');
    }
  }

  refreshRol(select: any){
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
      $(select).val('');
    });
  }

  idRolesFormulario() {
    this.listaRolesSeleccionados.forEach((rol) => {
      this.listaRolesSeleccionadosId.push(rol.idRol);
    });
  }

  idRoles(): Number[] {
    let ids: Number[] = [];
    this.listaRolesSeleccionados.map((roles) => ids.push(roles.idRol));
    return ids;
  }

  aceptar() {
    $('#aceptarModal').modal('hide');
    this.router.navigate(['/intermediario/administracion/modificarUsuarioIf']);
  }

  formatPipe(){
    this.setPipeForm('ventaIncialAtendido');    
    this.setPipeForm('ventaFinalAtendido');
  }

  setPipeForm(controlName: string) {
    const control = this.editarUsuarioIFForm.get(controlName);
    if (control) {      
      control.valueChanges.subscribe(value => {
        if (value !== null && value !== '') {
          const nuevoValor = this.cambiarFormatoNumero(value);
          control.patchValue(nuevoValor, { emitEvent: false });
        }
      });
    }     
  }

  cambiarFormatoNumero(value: any): string {
    let stringValue = String(value).replace(/[^\d]/g, '');
    stringValue = stringValue.replace(/^0+/, '');
    const parts = stringValue.split('.');
    parts[0] = this.formatThousandsSeparator(parts[0], '.');
    return parts.join('.');
  }

  /** Formato miles sin regex vulnerable (evita ReDoS). */
  private formatThousandsSeparator(s: string, sep: string): string {
    if (!s) return s;
    let out = '';
    for (let i = 0; i < s.length; i++) {
      if (i > 0 && (s.length - i) % 3 === 0) out += sep;
      out += s[i];
    }
    return out;
  }

  actualizarDepartamentos() {
    if (this.editarUsuarioIFForm.controls.aplicaTodosDepartamentos.value) {
      this.editarUsuarioIFForm.get('departamentosSeleccionados').setValue(null);
      setTimeout(() => {
        $('#departamentosSeleccionados').val('');
        $('#departamentosSeleccionados').prop('disabled', true);
        $('.selectpicker').selectpicker('refresh');
      });
    } else {
      setTimeout(() => {
        $('#departamentosSeleccionados').prop('disabled', false);
        $('.selectpicker').selectpicker('refresh');
      });
    }
  }
}
